"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2230],{

/***/ 82230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_PackagesCarousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./src/components/ScrollableDealModule/index.tsx + 1 modules
var ScrollableDealModule = __webpack_require__(271);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/fetch/index.js
var fetch = __webpack_require__(63144);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);
;// CONCATENATED MODULE: ./src/hooks/useFetchPackages.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var PACKAGE_DISPLAY_MINIMUM = 3;
var PACKAGE_PRICE_CACHE_ENDPOINT = '/pws/v0/psapi/search/pricecache';
function setDealContent(deals) {
    return deals.map(function(deal) {
        return _objectSpread({}, deal, {
            id: "PACKAGE_DEAL_".concat(deal.cityName.slice(-2)),
            image: deal.cityImageUrl,
            imageHeight: '284px',
            gaCategory: 'PACKAGES_LANDING',
            gaAction: 'Cached Deal',
            strikePrice: deal.priceAmount < deal.retailPriceAmount ? deal.retailPriceAmount : 0,
            gaLabel: deal.cityName,
            navArray: [
                {
                    href: deal.searchLink,
                    target: '_blank'
                }
            ]
        });
    });
}
var useFetchPackages = function(param) {
    var latitude = param.latitude, longitude = param.longitude;
    var queryString = latitude !== null && longitude !== null ? "?latitude=".concat(latitude, "&longitude=").concat(longitude) : '';
    var url = "".concat(PACKAGE_PRICE_CACHE_ENDPOINT).concat(queryString);
    var ref = (0,react.useState)([]), deals = ref[0], setDeals = ref[1];
    var ref1 = (0,react.useState)(true), didFetchSucceed = ref1[0], setFetchSucceeded = ref1[1];
    (0,react.useEffect)(function() {
        var fetchPackageDeals = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var priceCacheResponse, priceCacheJson, _packages, packages, packageDeals;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return fetch_default()(url, {
                                headers: {
                                    'Cache-Control': 'private, max-age=900'
                                }
                            });
                        case 3:
                            priceCacheResponse = _ctx.sent;
                            _ctx.next = 6;
                            return priceCacheResponse.json();
                        case 6:
                            priceCacheJson = _ctx.sent;
                            _packages = priceCacheJson.packages, packages = _packages === void 0 ? [] : _packages;
                            if (!(!Array.isArray(packages) || packages.length < PACKAGE_DISPLAY_MINIMUM)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error('API call failed or not enough packages to display');
                        case 10:
                            setFetchSucceeded(true);
                            packageDeals = setDealContent(packages);
                            setDeals(packageDeals);
                            _ctx.next = 18;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            setFetchSucceeded(false);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }));
            return function fetchPackageDeals() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPackageDeals();
    }, [
        url
    ]);
    return {
        deals: deals,
        didFetchSucceed: didFetchSucceed
    };
};
/* harmony default export */ var hooks_useFetchPackages = (useFetchPackages);

// EXTERNAL MODULE: ./src/hooks/useGeoPosition.ts
var useGeoPosition = __webpack_require__(99856);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
;// CONCATENATED MODULE: ./src/components/Skeleton/index.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    transform: translateX(-200px)\n  }\n  100% {\n    transform: translateX(",
        "px)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #eee;\n  background-size: 200px 100%;\n  background-repeat: no-repeat;\n  display: inline-block;\n  line-height: 1;\n  width: ",
        ";\n  ",
        "\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  background-image: linear-gradient(\n    to right,\n    rgba(245, 245, 245, 0) 0%,\n    rgba(245, 245, 245, 1) 50%,\n    rgba(245, 245, 245, 0) 100%\n  );\n  background-image: -webkit-linear-gradient(\n    left,\n    rgba(245, 245, 245, 0) 0%,\n    rgba(245, 245, 245, 1) 50%,\n    rgba(245, 245, 245, 0) 100%\n  );\n  animation: ",
        " 1.2s ease-in-out infinite;\n  height: 100%;\n  width: 200px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var animation = function(param) {
    var animationWidth = param.animationWidth;
    return (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject(), animationWidth);
};
var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-50412902-0"
})(_templateObject1(), function(props) {
    return props.width ? props.width : '100%';
}, function(props) {
    return props.height && "height: ".concat(props.height, ";");
});
var Glare = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-50412902-1"
})(_templateObject2(), animation);
var Skeleton = function(param) {
    var height = param.height, width = param.width, _animationWidth = param.animationWidth, animationWidth = _animationWidth === void 0 ? 100 : _animationWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        height: height,
        width: width,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Glare, {
            animationWidth: animationWidth + 200,
            children: "‌"
        })
    });
};
/* harmony default export */ var components_Skeleton = (Skeleton);

;// CONCATENATED MODULE: ./src/components/DealCarouselLoader/index.tsx
function DealCarouselLoader_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DealCarouselLoader_templateObject() {
    var data = DealCarouselLoader_taggedTemplateLiteral([
        "\n  height: 379px;\n"
    ]);
    DealCarouselLoader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ItemFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b533abb7-0"
})(DealCarouselLoader_templateObject());
var ItemCard = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        p: 3,
        boxShadowSize: "sm",
        borderWidth: 0,
        width: [
            1,
            null,
            null,
            1 / 3
        ],
        mx: [
            null,
            null,
            null,
            2
        ],
        my: [
            2,
            null
        ],
        borderRadius: "xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                        height: "200px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                                height: "20px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                                height: "20px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                                height: "20px"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var DealCarouselLoader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: 1200,
        "data-testid": "deal-carousel-loader",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            px: 3,
            py: 1,
            width: 1,
            borderWidth: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemFlex, {
                flexDirection: [
                    'column',
                    null,
                    null,
                    'row'
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCard, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCard, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCard, {})
                ]
            })
        })
    });
};
/* harmony default export */ var components_DealCarouselLoader = (DealCarouselLoader);

;// CONCATENATED MODULE: ./src/components/PackagesCarousel/index.tsx







var PackagesCarousel = function(param) {
    var _heading = param.heading, heading = _heading === void 0 ? "Don't miss these package deals" : _heading, _headingMobile = param.headingMobile, headingMobile = _headingMobile === void 0 ? "Don't miss these deals" : _headingMobile;
    var ref = (0,useGeoPosition/* default */.Z)(), longitude = ref.longitude, latitude = ref.latitude;
    var ref1 = hooks_useFetchPackages({
        latitude: latitude,
        longitude: longitude
    }), deals = ref1.deals, didFetchSucceed = ref1.didFetchSucceed;
    return didFetchSucceed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: 1280,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                px: 3,
                pb: 5,
                pt: 4,
                children: deals.length >= PACKAGE_DISPLAY_MINIMUM ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule/* default */.Z, {
                    content: {
                        heading: heading,
                        headingMobile: headingMobile,
                        dataArray: deals
                    },
                    handleNavOnClick: function(href) {
                        return window.open(href);
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DealCarouselLoader, {})
            })
        })
    }) : null;
};
/* harmony default export */ var components_PackagesCarousel = (PackagesCarousel);


/***/ }),

/***/ 271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ScrollableDealModule; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Heading/Heading.js
var Heading = __webpack_require__(97331);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/@pcln/content-tile/dist/esm/index.js + 4 modules
var esm = __webpack_require__(87809);
// EXTERNAL MODULE: ./node_modules/@pcln/price-box/dist/esm/index.js + 11 modules
var dist_esm = __webpack_require__(46364);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(80404);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowUp.js
var ArrowUp = __webpack_require__(25192);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowDown.js
var ArrowDown = __webpack_require__(79016);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowLeft.js
var ArrowLeft = __webpack_require__(88410);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowRight.js
var ArrowRight = __webpack_require__(91209);
;// CONCATENATED MODULE: ./src/components/ScrollableDealModule/ArrowButton.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 40px;\n  width: 40px;\n\n  &&& {\n    border-radius: 50%;\n    padding: 8px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var RoundButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-8220fd98-0"
})(_templateObject());
var iconLookup = {
    up: ArrowUp/* default */.Z,
    down: ArrowDown/* default */.Z,
    left: ArrowLeft/* default */.Z,
    right: ArrowRight/* default */.Z
};
var ArrowButton = function(_param) {
    var direction = _param.direction, disabled = _param.disabled, onClick = _param.onClick, label = _param.label, props = _objectWithoutProperties(_param, [
        "direction",
        "disabled",
        "onClick",
        "label"
    ]);
    var IconDirection = iconLookup[direction];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundButton, _objectSpread({}, props, {
        disabled: disabled,
        onClick: onClick,
        "data-testid": "arrow".concat(direction),
        "aria-label": label,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDirection, {})
    }));
};
/* harmony default export */ var ScrollableDealModule_ArrowButton = (ArrowButton);

;// CONCATENATED MODULE: ./src/components/ScrollableDealModule/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function ScrollableDealModule_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function ScrollableDealModule_templateObject() {
    var data = ScrollableDealModule_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n"
    ]);
    ScrollableDealModule_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = ScrollableDealModule_taggedTemplateLiteral([
        "\n  ",
        " {\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = ScrollableDealModule_taggedTemplateLiteral([
        "\n  text-decoration-line: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

/* eslint-disable react/destructuring-assignment */ 






var RemainingWidthFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-9bec3d6a-0"
})(ScrollableDealModule_templateObject());
var NoWrapText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-9bec3d6a-1"
})(_templateObject1(), theme/* mediaQueries.1 */.w5[1]);
var NoDecorationLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-9bec3d6a-2"
})(_templateObject2());
var TextSpan = Text/* default.span */.ZP.span;
var getImageTile = function(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ImageTile */.a5, {
                height: data.imageHeight,
                image: data.image,
                imageWebP: data.imageWebP,
                navArray: data.navArray,
                handleNavOnClick: isUsingNavArrows && handleNavOnClick,
                isOpaque: isOpaque,
                borderRadius: "xl",
                rounded: "top"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                color: "text",
                p: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "baseline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                fontSize: 0,
                                children: data.productName
                            }),
                            !!data.strikePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* StrikePrice */.Ch, {
                                price: data.strikePrice,
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "baseline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWrapText, {
                                        fontSize: 3,
                                        fontWeight: "bold",
                                        children: data.cityName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        fontSize: 0,
                                        mt: 1,
                                        children: data.description
                                    })
                                ]
                            }),
                            !!data.priceAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWrapText, {
                                mt: "1px",
                                ml: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "baseline",
                                    children: [
                                        isUsingPricePrefix && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSpan, {
                                            mx: 2,
                                            color: "pricePrimary",
                                            fontSize: 4,
                                            fontWeight: "bold",
                                            children: data.pricePrefix
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* PriceBox */.bz, {
                                            priceSize: "small",
                                            price: data.priceAmount,
                                            priceColor: "pricePrimary",
                                            priceType: isUsingPriceType && 'per person',
                                            alignItems: "right",
                                            toFixDecimal: 0
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// TODO: improve the list of params using "deeper" React pattern
var parseDealTiles = function(dataArray, isUsingNavArrows, isUsingPriceType, isUsingPricePrefix, isOpaque, position, numDealsToDisplay, isTrips, handleNavOnClick) {
    var items = dataArray.slice(position, position + numDealsToDisplay);
    return items.map(function(data, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            onClick: function() {
                analytics/* default.fireEvent */.Z.fireEvent({
                    action: data.gaAction,
                    category: data.gaCategory,
                    label: data.cityName
                });
            },
            mx: [
                0,
                2
            ],
            mb: index === dataArray.length - 1 ? 0 : [
                3,
                0
            ],
            borderRadius: "xl",
            boxShadowSize: "md",
            borderWidth: 0,
            width: [
                1,
                1 / numDealsToDisplay
            ],
            "data-testid": "deal-tile-".concat(data.cityName),
            children: isTrips ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                onClick: data.onTileClick,
                children: getImageTile(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoDecorationLink, {
                href: data.navArray[0].href,
                target: "_blank",
                children: getImageTile(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick)
            })
        }, "deal-tile-".concat(data.cityName));
    });
};
var ScrollableDealModule = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(ScrollableDealModule, _Component);
    var _super = _createSuper(ScrollableDealModule);
    function ScrollableDealModule(props) {
        _classCallCheck(this, ScrollableDealModule);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            position: 0,
            numDealsToDisplay: 0
        };
        _this.handleLeftArrowClick = _this.updatePosition.bind(_assertThisInitialized(_this), false);
        _this.handleRightArrowClick = _this.updatePosition.bind(_assertThisInitialized(_this), true);
        _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = ScrollableDealModule.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.setState({
            numDealsToDisplay: // eslint-disable-next-line no-nested-ternary
            window.innerWidth >= 1024 ? 3 : window.innerWidth >= 640 ? 2 : 1
        });
        window.addEventListener('resize', this.handleResize);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    };
    _proto.handleResize = function handleResize() {
        var screenSize = window.innerWidth;
        if (screenSize >= 1024 && this.state.numDealsToDisplay !== 3) {
            this.setState({
                numDealsToDisplay: 3
            });
        } else if (screenSize >= 640 && screenSize < 1024 && this.state.numDealsToDisplay !== 2) {
            this.setState({
                numDealsToDisplay: 2
            });
        } else if (screenSize < 640 && this.state.numDealsToDisplay !== 1) {
            this.setState({
                numDealsToDisplay: 1
            });
        }
    };
    _proto.updatePosition = function updatePosition(shouldAdd) {
        if (shouldAdd) {
            var maxIndex = this.props.content.dataArray.length - this.state.numDealsToDisplay;
            var nextPosition = this.state.position + this.state.numDealsToDisplay;
            var position = Math.min(nextPosition, maxIndex);
            this.setState({
                position: position
            });
        } else {
            var nextPosition1 = this.state.position - this.state.numDealsToDisplay;
            var position1 = Math.max(nextPosition1, 0);
            this.setState({
                position: position1
            });
        }
    };
    _proto.render = function render() {
        var _props = this.props, content = _props.content, handleNavOnClick = _props.handleNavOnClick, _isUsingNavArrows = _props.isUsingNavArrows, isUsingNavArrows = _isUsingNavArrows === void 0 ? true : _isUsingNavArrows, _isUsingPriceType = _props.isUsingPriceType, isUsingPriceType = _isUsingPriceType === void 0 ? true : _isUsingPriceType, _isUsingPricePrefix = _props.isUsingPricePrefix, isUsingPricePrefix = _isUsingPricePrefix === void 0 ? false : _isUsingPricePrefix, _isOpaque = _props.isOpaque, isOpaque = _isOpaque === void 0 ? true : _isOpaque, _isTrips = _props.isTrips, isTrips = _isTrips === void 0 ? false : _isTrips;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                    px: 3,
                    pb: 24,
                    fontSize: 4,
                    fontWeight: "bold",
                    m: 0,
                    color: "text.heading",
                    textStyle: "heading2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: content.heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            sm: true,
                            md: true,
                            lg: true,
                            xl: true,
                            xxl: true,
                            children: content.headingMobile
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        isUsingNavArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule_ArrowButton, {
                                color: "primary",
                                direction: "left",
                                mr: 3,
                                disabled: this.state.position === 0,
                                onClick: this.handleLeftArrowClick,
                                label: "Scroll backward through the deals"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RemainingWidthFlex, {
                            flexDirection: [
                                'column',
                                'row'
                            ],
                            mx: 2,
                            children: parseDealTiles(content.dataArray, isUsingNavArrows, isUsingPriceType, isUsingPricePrefix, isOpaque, this.state.position, this.state.numDealsToDisplay, isTrips, handleNavOnClick)
                        }),
                        isUsingNavArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule_ArrowButton, {
                                color: "primary",
                                direction: "right",
                                disabled: this.state.position >= content.dataArray.length - this.state.numDealsToDisplay,
                                onClick: this.handleRightArrowClick,
                                label: "Scroll forward through the deals"
                            })
                        })
                    ]
                })
            ]
        });
    };
    return ScrollableDealModule;
}(react.Component);
/* harmony default export */ var components_ScrollableDealModule = (ScrollableDealModule);


/***/ }),

/***/ 99856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1377);


var useGeoPosition = function() {
    var locale = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(locale.longitude ? locale.longitude : null), longitude = ref[0], setLongitude = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(locale.latitude ? locale.latitude : null), latitude = ref1[0], setLatitude = ref1[1];
    var onSuccess = function(param) {
        var coords = param.coords;
        setLongitude(coords.longitude);
        setLatitude(coords.latitude);
    };
    var onError = function() {
    // TODO: fail silently or log error
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var geo = navigator.geolocation;
        if (!geo) {
            // TODO: potentially log error
            return;
        }
        geo.getCurrentPosition(onSuccess, onError);
    }, []);
    return {
        longitude: longitude,
        latitude: latitude
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGeoPosition);


/***/ })

}]);